import React from 'react';
import { Section } from './Section';
import { Button } from './Button';
import { ShieldCheck, Mail, Lock } from 'lucide-react';
export function FinalCTA() {
  return <Section className="bg-sage-800 text-white pb-24" data-id="element-70">
      <div className="max-w-3xl mx-auto text-center" data-id="element-71">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-72">
          Sentate mañana a la mañana con tu kit listo y empezá.
        </h2>

        <p className="text-xl text-sage-100 mb-10 leading-relaxed" data-id="element-73">
          Sin vueltas. Sin excusas. Sin cosas complicadas. El Kit Mente Clara &
          Activa es tu compañero diario para cuidar lo más importante que tenés:
          tu cabeza.
        </p>

        <Button href="#pricing" variant="secondary" className="text-xl px-10 py-5 mb-8 w-full sm:w-auto" data-id="element-74">
          ✅ ACCEDER AL KIT AHORA
        </Button>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-sm text-sage-200" data-id="element-75">
          <span className="flex items-center gap-2" data-id="element-76">
            <Lock size={18} data-id="element-77" />
            Compra segura
          </span>
          <span className="hidden sm:inline text-sage-600" data-id="element-78">•</span>
          <span className="flex items-center gap-2" data-id="element-79">
            <Mail size={18} data-id="element-80" />
            Acceso inmediato
          </span>
          <span className="hidden sm:inline text-sage-600" data-id="element-81">•</span>
          <span className="flex items-center gap-2" data-id="element-82">
            <ShieldCheck size={18} data-id="element-83" />
            Garantía 7 días
          </span>
        </div>
      </div>
    </Section>;
}